export default __webpack_public_path__ + "static/media/products.5d666017.jpg";